import React, {useState} from "react";
import {Button, Form, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import * as GroupGameService from "../../api/GroupGameService"
import {useNavigate} from "react-router-dom";
import style from "./SideBar.module.css";
import {useTranslation} from "react-i18next";

function HistoryComment(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'historyComment' });
    const [comment, setComment] = useState(props.commentText)
    const nav = useNavigate()

    function saveComment() {
        GroupGameService.postStepComment(
            props.gameId,
            props.stepId,
            comment !== undefined ? comment : props.commentText,
            () => props.updateGameState(),
            () => window.alert(t('couldNotSaveError'))
        )
        props.onClose()
    }

    function storeComment(event) {
        setComment(event.target.value)
    }

    return (
        <Modal
            show={true}
            onHide={props.onClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={style.modalText}
        >
            <ModalHeader closeButton>
                <ModalTitle>{t('stepComment')}</ModalTitle>
            </ModalHeader>
            <ModalBody style={{backgroundColor: "#FCF2ED"}}>
                <Form>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        onChange={e => storeComment(e)}
                        value={comment}
                        autoFocus={true}
                        onFocus={(e)=> {e.target.selectionStart = comment?.length}}
                    />
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button variant="primary" onClick={saveComment} style={{backgroundColor: "#59619B"}}>
                    {t('saveButton')}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default HistoryComment